<template>
  <article
    v-if="product"
    id="product"
    class="position-relative d-flex align-items-center justify-content-between flex-column border-r-17 bg-color-white overflow-hidden px-4 py-4"
  >
    <template v-if="product.major_final_price">
      <DiscountTag
        :max_discount_variety="product.max_discount_variety"
        :finalPrice="product.major_final_price"
      />
    </template>

    <a @click.prevent="cachProduct" :href="to.href">
      <div class="recommended-products-img">
        <img
          loading="lazy"
          v-if="mainImage"
          :src="getImage(mainImage, 'lg')"
          :alt="product.title"
        />
        <img
          loading="lazy"
          v-else
          class="skeleton-image"
          :alt="product ? product.title : ''"
        />
      </div>
    </a>
    <h2
      class="w-100 text-center fontsize-large font-w-700 text-color-theme-dark title-products-overflow m-0"
    >
      {{ product.title }}
    </h2>
    <div v-if="product.status == 'available'" class="">
      <div class="text-center" v-if="discountAmount != 0">
        <span
          class="line-through font-w-400 fontsize-heavy text-color-theme-grey1"
          >{{ (mainPrice + discountAmount) | price }}</span
        >
      </div>
      <div>
        <span class="fontsize-heavy font-w-700 text-color-theme-dark">{{
          mainPrice | price
        }}</span>
        <span class="fontsize-medium font-w-500 text-color-theme-dark pr-1"
          >تومان</span
        >
      </div>
    </div>
    <div v-else>
      <span
        v-if="product.status == 'out_of_stock'"
        class="text-color-red font-s-14"
      >
        تمام شد
      </span>
      <span v-if="product.status == 'soon'" class="text-color-red font-s-14">
        به زودی
      </span>
    </div>
    <a
      class="d-flex align-items-center justify-content-center gap-10 w-100 px-3 py-2 bg-color-theme2 border-r-10"
      @click.prevent="cachProduct"
      :href="to.href"
    >
      <span class="fontsize-mini font-w-400 text-color-white w-s-nowrap">مشاهده بیشتر</span>
      <span><ShoppingBag /></span>
    </a>
  </article>
</template>

<script>
import { BSkeleton } from "bootstrap-vue";
import { getImage } from "@/libraries/functions";
import Tick from "@/parts/Front/components/shared/Tick";
import ShoppingBag from "@/parts/Front/components/Icon/ShoppingBag.vue";
import DiscountTag from "@/parts/Front/components/product/DiscountTag.vue";

export default {
  name: "Product",
  components: {
    Tick,
    BSkeleton,
    ShoppingBag,
    DiscountTag,
  },
  props: {
    product: Object,
    lowOpacity: Boolean,
    comparable: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  methods: {
    getImage,
    cachProduct() {
      let product = this.product;
      product.isPreview = true;
      this.$store.commit("front/setProductLinkedInfo", product);
      this.$router.push(this.to.href);
    },
  },
  computed: {
    to() {
      return this.$router.resolve({
        name: "product.detail",
        params: { id: this.product.id, slug: this.product.slug },
      });
    },
    mainPrice() {
      // jor keshi front
      let sort =
        this.$route.query.sort &&
        (this.$route.query.sort == "high_to_low" ||
          this.$route.query.sort == "low_to_high");
      return sort
        ? this.product
          ? this.$route.query.sort == "low_to_high"
            ? this.product.minor_variety_price
            : this.product.major_variety_price
          : null
        : this.product
        ? this.product.price
        : null;
    },
    discountAmount() {
      return this.product ? this.product.major_discount_amount : null;
    },
    mainImage() {
      return this.product ? this.product.major_image : null;
    },
    isComparing() {
      return Boolean(
        this.$store.getters["front/getCompares"].find(
          (i) => i.id == this.product.id
        )
      );
    },
  },
};
</script>

<style scoped>
#product {
  box-shadow: 0px 0px 28.919540405273438px 3.908045768737793px #bababa63;
  gap: 10px;
}
.title-products-overflow {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.skeleton-image {
  width: 308px;
  display: inline-block;
  background-image: radial-gradient(
    rgb(244, 244, 244),
    rgb(244, 244, 244),
    rgb(244, 244, 244)
  );
}
@media screen and (max-width:768) {
  #product {
    gap: 5px;
  }
}
</style>
